module.exports = __webpack_public_path__ + "media/images/receive-c1e9eb1e4ecba3f4d16914411e01a618.png";